/**
 * Global utility to convert from Dollars to cents
 *
 * @param value
 */
export let dollarsToCents = function (value) {
  value = value.toString().replace(/[^\d.-]/g, '');
  if (value && value.includes('.')) {
    value = value.substring(0, value.indexOf('.') + 3);
  }

  return value ? Math.round(parseFloat(value) * 100) : 0;
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/dollarsToCents.utils.ts